import React from 'react';
import { translate } from 'react-i18next';
import { Segment, Header, Button, Container, Grid, Message, Icon } from 'semantic-ui-react';

import Instructions from '../Instructions.js';
import DigitalTimer from '../DigitalTimer.js';
import ChallengeUtils  from 'utils/ChallengeUtils.js';
import Utils from 'utils/Utils.js';

import {colors} from 'style';
import styleDef from './style.js'
var style= {
    ...styleDef,
    containerExpanded: {
        padding:'0px 10px 0px 10px',
    },
    restartButton: {
        position: 'relative',
        left: '110px',
        top: '102px',
        backgroundColor: '#fff',
        border: '4px solid ' + colors.pointsYellow,
        borderRadius: '50%',
        width: '40px',
        height: '40px',
        color: colors.pointsYellow,
        margin: '0',
        padding: '10px 10px 10px 10px',
        fontSize: '1.5em',
        lineHeight: '12px',
        cursor: 'pointer',
    },
    reloadIcon: {
        position: 'relative',
        left: '-5px',
    },
    completeButton: {
        backgroundColor: '#fff',
        border: '16px solid ' + colors.themeTeal,
        borderRadius: '50%',
        width: '160px',
        height: '160px',
        color: colors.themeTeal,
        margin: '0',
        padding: '10px 10px 10px 10px',
        fontSize: '1.5em',
        lineHeight: '12px',
        cursor: 'pointer',
    },
    completeIcon: {
        position: 'relative',
        top: '20px',
        left: '-2px',
        fontSize: '90px',
        fontWeight: 'bold',
    },
    timer: {
        fontSize: '2em',
        color: colors.themeBlue,
    }
};

const CountUp = ({t,
                  challenge, 
                  buttonText,
                  ellapsedTime, 
                  error, 
                  onComplete, 
                  onRestartTimer,
                  completePending}) => (
    <Container style={{...style.container, ...style.containerExpanded}}>
        <div style={style.containerDiv}>
        <Segment style={style.segment}>
            <Grid style={style.grid} centered columns={1}>
                <Grid.Row verticalAlign='top' style={style.topRow}>
                    <Grid.Column verticalAlign='top'>
                        <div style={{...style.imageBanner, backgroundImage:Utils.url(ChallengeUtils.getChallengeImageUrl(challenge))}}/>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row verticalAlign='middle'>
                    <Grid.Column verticalAlign='middle'>
                        <Instructions challenge={challenge} />
                        <DigitalTimer time={ellapsedTime} style={style.timer}  />
                        <br/>
                        <div>
                            <button style={style.restartButton} onClick={onRestartTimer}>
                                <i style={style.reloadIcon} className='icon-reload-alt' />
                            </button>
                        </div>
                        <button style={style.completeButton} onClick={onComplete}>
                            <i style={style.completeIcon} className='icon-check2' />
                        </button>
                    </Grid.Column>
                </Grid.Row>
              
                <Grid.Row verticalAlign='bottom'>
                    <Grid.Column verticalAlign='bottom' textAlign='left'>
                        {error &&
                        <Message negative>
                            <Message.Header>{t('Error')}</Message.Header>
                            <p>{error}</p>
                        </Message>
                        }
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Segment>
    </div>
    </Container>
);

export default translate('challenges')(CountUp);



// WEBPACK FOOTER //
// ./src/modules/challenges/types/screens/CountUp.js